export default "__VITE_ASSET__BZzBV92H__"